export default {
	primary: '#d2aa5c',
	secundary: '#fff',
	white: '#fff',
	dark: '#222',
	regular: '#555',
	light: '#888',
	lighter: '#eee'
};
